"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var defaults = {
  successfulCalendarIds: (0, _immutable.List)(),
  failedCalendarErrors: (0, _immutable.Map)()
};

var CalendarVerification =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(CalendarVerification, _Record);

  function CalendarVerification() {
    (0, _classCallCheck2.default)(this, CalendarVerification);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CalendarVerification).apply(this, arguments));
  }

  (0, _createClass2.default)(CalendarVerification, null, [{
    key: "from",
    value: function from(json) {
      return new CalendarVerification({
        successfulCalendarIds: (0, _immutable.List)(json.successfulCalendarIds),
        failedCalendarErrors: (0, _immutable.Map)(json.failedCalendarErrors)
      });
    }
  }]);
  return CalendarVerification;
}((0, _immutable.Record)(defaults));

exports.default = CalendarVerification;
module.exports = exports.default;